import { render, staticRenderFns } from "./SelectOrAddPoiListMini.vue?vue&type=template&id=3240beac"
import script from "./SelectOrAddPoiListMini.vue?vue&type=script&lang=js"
export * from "./SelectOrAddPoiListMini.vue?vue&type=script&lang=js"
import style0 from "./SelectOrAddPoiListMini.vue?vue&type=style&index=0&id=3240beac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports